import React from "react";
import notfound from "../../img/notfound.png";

const NotFound = () => {
  return (
    <div>
      <img src={notfound} alt="" />
    </div>
  );
};

export default NotFound;
